import React, { memo } from "react";
import { Handle } from "react-flow-renderer";
import { useNodeStorage } from "../../../stores/useNodeStorage";

const TrashIcon = () => (
  <svg width="11" height="11" viewBox="0 0 24 24" fill="currentColor">
    <path d="M9 3V4H4V6H5V20C5 21.1 5.9 22 7 22H17C18.1 22 19 21.1 19 20V6H20V4H15V3H9ZM7 6H17V20H7V6ZM9 8V18H11V8H9ZM13 8V18H15V8H13Z"/>
  </svg>
);
const DupeIcon = () => (
  <svg width="11" height="11" viewBox="0 0 24 24" fill="currentColor">
    <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/>
  </svg>
);

function formatTime(data) {
  if (data.value && data.unit) {
    const labels = { sec: ["segundo", "segundos"], min: ["minuto", "minutos"], hour: ["hora", "horas"], day: ["dia", "dias"] };
    const pair = labels[data.unit] || [data.unit, data.unit + "s"];
    return `${data.value} ${data.value === 1 ? pair[0] : pair[1]}`;
  }
  const s = data.sec || 0;
  if (s >= 86400 && s % 86400 === 0) { const v = s / 86400; return `${v} ${v === 1 ? "dia" : "dias"}`; }
  if (s >= 3600 && s % 3600 === 0) { const v = s / 3600; return `${v} ${v === 1 ? "hora" : "horas"}`; }
  if (s >= 60 && s % 60 === 0) { const v = s / 60; return `${v} ${v === 1 ? "minuto" : "minutos"}`; }
  return `${s} ${s === 1 ? "segundo" : "segundos"}`;
}

export default memo(({ data, isConnectable, id }) => {
  const storageItems = useNodeStorage();
  const timeLabel = formatTime(data);

  return (
    <div style={{
      background: "#ffffff",
      borderRadius: 14,
      border: "1.5px solid #d1fae5",
      boxShadow: "0 4px 16px rgba(16, 185, 129, 0.10), 0 1px 4px rgba(0,0,0,0.04)",
      minWidth: 200,
      fontFamily: "Inter, ui-sans-serif, system-ui, sans-serif",
      position: "relative",
      overflow: "visible",
    }}>
      {/* Action buttons */}
      <div style={{ position: "absolute", top: -32, right: 0, display: "flex", gap: 6 }}>
        <button
          style={{ width: 26, height: 26, borderRadius: "50%", background: "#3b82f6", border: "none", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", color: "#fff" }}
          title="Duplicar"
          onClick={() => { storageItems.setNodesStorage(id); storageItems.setAct("duplicate"); }}
        ><DupeIcon /></button>
        <button
          style={{ width: 26, height: 26, borderRadius: "50%", background: "#ef4444", border: "none", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", color: "#fff" }}
          title="Excluir"
          onClick={() => { storageItems.setNodesStorage(id); storageItems.setAct("delete"); }}
        ><TrashIcon /></button>
      </div>

      {/* Input handle */}
      <Handle
        type="target"
        position="left"
        style={{ left: -8, top: 28, background: "#10b981", width: 14, height: 14, border: "2px solid #fff", boxShadow: "0 2px 8px rgba(16,185,129,0.35)" }}
        isConnectable={isConnectable}
      />

      {/* Header */}
      <div style={{
        display: "flex", alignItems: "center", gap: 10,
        padding: "12px 14px 10px",
        borderBottom: "1px solid rgba(16,185,129,0.12)",
      }}>
        <div style={{
          width: 32, height: 32, borderRadius: 10,
          background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
          display: "flex", alignItems: "center", justifyContent: "center",
          flexShrink: 0, boxShadow: "0 4px 10px rgba(16,185,129,0.30)",
        }}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="white">
            <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67V7z"/>
          </svg>
        </div>
        <span style={{ fontWeight: 700, fontSize: 13, color: "#0f172a", letterSpacing: "-0.01em" }}>
          Aguardar
        </span>
      </div>

      {/* Content */}
      <div style={{ padding: "10px 14px 12px" }}>
        <div style={{
          display: "inline-flex", alignItems: "center", gap: 6,
          background: "rgba(16, 185, 129, 0.08)",
          border: "1px solid rgba(16, 185, 129, 0.25)",
          borderRadius: 20, padding: "6px 14px",
        }}>
          <svg width="13" height="13" viewBox="0 0 24 24" fill="#059669">
            <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67V7z"/>
          </svg>
          <span style={{ fontSize: 13, fontWeight: 700, color: "#065f46" }}>{timeLabel}</span>
        </div>

        {/* Output label */}
        <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", marginTop: 10, paddingRight: 4 }}>
          <span style={{ fontSize: 11, color: "#94a3b8", fontWeight: 500 }}>Próxima etapa</span>
        </div>
      </div>

      {/* Output handle */}
      <Handle
        type="source"
        position="right"
        id="a"
        style={{ right: -8, bottom: 18, top: "auto", background: "#6366f1", width: 14, height: 14, border: "2px solid #fff", boxShadow: "0 2px 8px rgba(99,102,241,0.35)" }}
        isConnectable={isConnectable}
      />
    </div>
  );
});
